import { 
  GET_USERS,
  ADD_USER,
  EDIT_USER,
  DELETE_USER,
  EXPORT_USER,
  CLEAR_DATA,
  LOGOUT
} from '../action';

const initialState = {
  page: 0,
  totalPage: 0,
  totalUsers: 0,

  isGettingUsers: false,
  isGottenUsersSuccess: false,
  isGottenUsersFail: false,

  users: [],

  isAddingUser: false,
  isAddedUserSuccess: false,
  isAddedUserFail: false,

  isEditingUser: false,
  isEditedUserSuccess: false,
  isEditedUserFail: false,

  isDeletingUser: false,
  isDeletedUserSuccess: false,
  isDeletedUserFail: false,

  isExporting: false,
  isExportedSuccess: false,
  isExportedFail: false,
  exportPercent: null,
  exportData: [],
  
};

export default (state = initialState, action) => {
  switch (action.type) {
    
    case GET_USERS.REQUEST:
      return {
        ...state,
        isGettingUsers: true,
        isGottenUsersSuccess: false,
        isGottenUsersFail: false,
        users: [],
      
      };
    case GET_USERS.SUCCESS:
      return {
        ...state,
        isGettingUsers: false,
        isGottenUsersSuccess: true,
        isGottenUsersFail: false,
        users: [...action.data.users],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalUsers: action.data.totalUsers,
      };
    case GET_USERS.FAIL:
      return {
        ...state,
        isGettingUsers: false,
        isGottenUsersSuccess: false,
        isGottenUsersFail: true,
        users: [],
      };
    
    case ADD_USER.REQUEST:
      return {
        ...state,
        isAddingUser: true,
        isAddedUserSuccess: false,
        isAddedUserFail: false,
      };
    case ADD_USER.SUCCESS:
      return {
        ...state,
        isAddingUser: false,
        isAddedUserSuccess: true,
        isAddedUserFail: false,
        users: [...action.data.users],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalUsers: action.data.totalUsers,
      };
    case ADD_USER.FAIL:
      return {
        ...state,
        isAddingUser: false,
        isAddedUserSuccess: false,
        isAddedUserFail: action.data.error ? false : true,
      };
    
    case EDIT_USER.REQUEST:
      return {
        ...state,
        isEditingUser: true,
        isEditedUserSuccess: false,
        isEditedUserFail: false,
      };
    case EDIT_USER.SUCCESS:
      return {
        ...state,
        isEditingUser: false,
        isEditedUserSuccess: true,
        isEditedUserFail: false,
        users: [...action.data.users],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalUsers: action.data.totalUsers,
      };
    case EDIT_USER.FAIL:
      return {
        ...state,
        isEditingUser: false,
        isEditedUserSuccess: false,
        isEditedUserFail: action.data.error ? false : true,
      };

    case DELETE_USER.REQUEST:
      return {
        ...state,
        isDeletingUser: true,
        isDeletedUserSuccess: false,
        isDeletedUserFail: false,
      };
    case DELETE_USER.SUCCESS:
      return {
        ...state,
        isDeletingUser: false,
        isDeletedUserSuccess: true,
        isDeletedUserFail: false,
        users: [...action.data.users],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalUsers: action.data.totalUsers,
      };
    case DELETE_USER.FAIL:
      return {
        ...state,
        isDeletingUser: false,
        isDeletedUserSuccess: false,
        isDeletedUserFail: action.data.error ? false : true,
      };
    
    case EXPORT_USER.REQUEST: 
      return {
        ...state,
        isExporting: true,
        isExportedSuccess: false,
        isExportedFail: false,
        exportPercent: state.exportPercent === null || state.exportPercent === 100 ? 0 : state.exportPercent,
        exportData: state.exportPercent === 100 ? [] : state.exportData,
      };
    case EXPORT_USER.SUCCESS: 
      return {
        ...state,
        isExporting: false,
        isExportedSuccess: true,
        isExportedFail: false,
        exportPercent: action.data.exportPercent,
        exportData: [...state.exportData, ...action.data.exportData],
      };
    case EXPORT_USER.FAIL: 
      return {
        ...state,
        isExporting: false,
        isExportedSuccess: false,
        isExportedFail: true,
        exportPercent: null,
        exportData: [],
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
